import Dialog from "@material-ui/core/Dialog";
import {
    Box,
    Button,
    Grid, Tab,
    TextField
} from "@material-ui/core";
import * as React from "react";
import {withStyles} from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogActions from "@material-ui/core/DialogActions";
import {useEffect, useState} from "react";
import {convertCurrencyFormat, convertToBirthDate} from "../../utils/numberConvertor";
import {otherPaymentKinds, OtherPaymentService} from "../OtherPayments/OtherPaymentService";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import moment from "jalali-moment";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {Pagination, TabContext, TabList, TabPanel} from "@material-ui/lab";
import {css} from "@emotion/css";
import CustomTable from "../customTable/CustomTable";

const AddOtherNewPayments = ({openDialog, handleClose, selectedItem, needRefresh}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new OtherPaymentService(fundID, token, snackbar, loading)

    // state-start
    const [title, setTitle] = useState('')
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [unit, setUnit] = useState('')
    const [amountPerUnit, setAmountPerUnit] = useState("")
    const [expirationDate, setExpirationDate] = useState(true)
    const [description, setDescription] = useState("");
    const [enabled, setEnabled] = useState(true)

    const [pageCount, setPageCount] = useState(0);
    const [itemCount, setItemCount] = useState(0);
    const [buyRequestsList, setBuyRequestsList] = useState([]);
    let buyRequestPage = 0

    useEffect(() => {
        clearFields()
        if (selectedItem !== -1) {
            getPaymentInfo()
            getBuyRequestList()
        }
    }, [selectedItem])

    function getPaymentInfo() {
        loading(setLoadingStateDispatch(true))
        service.getOtherPaymentContent(
            selectedItem
        ).then(response => {
            setTitle(response.title)
            setStartDate(response.startDate ? moment(response.startDate, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : "")
            setEndDate(response.endDate ? moment(response.endDate, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : "")
            setUnit(response.unit)
            setAmountPerUnit(response.amountPerUnit)
            setExpirationDate(response.hasExpiredTime)
            setEnabled(response.enabled)
            setDescription(response.description)
            loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason, "خطا در دریافت جزئیات پرداختی!", snackbar, loading)

        })
    }


    function getBuyRequestList() {
        loading(setLoadingStateDispatch(true))
        service.getBuyRequestsList(
            buyRequestPage,
            selectedItem
        ).then(response => {
            setPageCount(response.totalPage)
            setItemCount(response.numberOfItems)
            setBuyRequestsList(prepareBuyRequestData(response.data))
            loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت اطلاعات پرداخت ها!"))
            loading(setLoadingStateDispatch(false))
        })
    }

    function prepareBuyRequestData(data) {
        let _data = []
        data.map((item, index) => {
            _data.push({
                number: (buyRequestPage * 10) + index + 1,
                fullName: `${item.firstName} ${item.lastName}`,
                nationalCode: item.nationalCode,
                phoneNumber: item.phoneNumber ? item.phoneNumber : "-",
                doAt: item.doAt ? moment(item.doAt, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : "-",
                price: item.amount ? convertCurrencyFormat(item.amount) : "صفر",
                amount: "نامشخص"
            })
        })
        return _data
    }

    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });
    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    const DialogActions = withStyles((theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(1),
        },
    }))(MuiDialogActions);

    function doChange() {
        if (checkFields()) {
            needRefresh(true)
            if (selectedItem === -1) {
                service.addNewPayment(
                    fundID,
                    service.prepareOtherPaymentJson(
                        title,
                        startDate,
                        endDate,
                        unit,
                        amountPerUnit,
                        expirationDate,
                        description,
                        enabled
                    ),
                    clearFields
                )
            } else {
                service.updatePayment(
                    fundID,
                    selectedItem,
                    service.prepareOtherPaymentJson(
                        title,
                        startDate,
                        endDate,
                        unit,
                        amountPerUnit,
                        expirationDate,
                        description,
                        enabled
                    )
                )
            }
        }
    }

    function clearFields() {
        setTitle("")
        setStartDate("")
        setEndDate("")
        setUnit("")
        setAmountPerUnit("")
        setDescription("")
        setExpirationDate(true)
        setEnabled(true)
        setSelectedTab(tabTypes.INFO)
        buyRequestPage = 0
    }

    function checkFields() {
        let message = ""
        let status = true
        if (title.trim().length === 0) {
            message = "لطفا عنوان پرداختی را وارد نمایید!"
            status = false
        }

        snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))
        return status
    }

    //Dialog-end

    const [selectedTab, setSelectedTab] = useState(tabTypes.INFO);

    function handleTabChange(event, newValue) {
        setSelectedTab(newValue);
    }


    function handleChange(event, value) {
        buyRequestPage = value - 1
        getBuyRequestList()
    }

    return (
        <Dialog fullScreen onClose={handleClose} aria-labelledby="customized-dialog-title" open={openDialog}
                id="customized-full-screen-dialog">
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                {selectedItem === -1 ? 'افزودن سایر پرداخت جدید' : 'مشاهده سایر پرداخت'}
            </DialogTitle>
            <div className={css`padding: 0 1rem 1rem 1rem;
              height: 100%;
              display: flex;
              flex-direction: column;`}>
                <TabContext value={selectedTab}>
                    <TabList
                        id="default-tab-container"
                        onChange={handleTabChange}>
                        <Tab label={"مشخصات"} value={tabTypes.INFO}/>
                        <Tab label={`سابقه خرید`} value={tabTypes.BUY_LIST}
                             className={selectedItem === -1 ? "d-none" : ""}/>
                    </TabList>
                    <TabPanel value={tabTypes.INFO}>
                        <section className="flex-grow-1 d-flex flex-column">
                            <Box className="flex-grow-1 w-100" sm={12}>
                                <Grid className='d-flex flex-row flex-wrap flex-grow-1 w-100' sm={12}
                                      style={{marginTop: '1rem'}}>
                                    <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                        <TextField className='w-100' variant="outlined" label="عنوان *"
                                                   value={title} onChange={e => {
                                            setTitle(e.target.value)
                                        }}/>
                                    </Grid>
                                    <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                        <TextField className='w-100' variant="outlined" label="تاریخ شروع"
                                                   value={convertToBirthDate(startDate)} onChange={e => {
                                            setStartDate(convertToBirthDate(e.target.value))
                                        }}/>
                                    </Grid>
                                    <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                        <TextField className='w-100' variant="outlined" label="تاریخ پایان"
                                                   value={convertToBirthDate(endDate)} onChange={e => {
                                            setEndDate(convertToBirthDate(e.target.value))
                                        }}/>
                                    </Grid>
                                    <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                        <TextField className='w-100' variant="outlined" label="واحد"
                                                   value={unit} onChange={e => {
                                            setUnit(e.target.value)
                                        }}
                                                   placeholder="کیلوگرم، کارتن، عدد و ..."
                                        />
                                    </Grid>
                                    <Grid sm={6} md={4} lg={4} xl={3} className='p-2 w-100'>
                                        <TextField className='w-100' variant="outlined" label="مبلغ هر واحد (ریال)"
                                                   value={convertCurrencyFormat(amountPerUnit)} onChange={e => {
                                            setAmountPerUnit(e.target.value.replaceAll(",", ""))
                                        }}/>
                                    </Grid>
                                    <Grid sm={12} md={4} lg={4} xl={3} className='p-2 w-100'>
                                        <label id='dateStatus' className="toggle-switch-content">
                                            <span className="toggle-title">با تاریخ انقضا / بدون تاریخ انقضا</span>
                                            <label className="switch" htmlFor="dateStatus">
                                                <input
                                                    type="checkbox"
                                                    id="dateStatus"
                                                    checked={expirationDate}
                                                    onChange={e => {
                                                        setExpirationDate(e.target.checked)
                                                    }}
                                                />
                                                <span className="toggle round"/>
                                            </label>
                                        </label>
                                    </Grid>
                                    <Grid sm={12} md={12} lg={12} xl={12} className='p-2 w-100'>
                                        <TextField
                                            multiline
                                            rows={5}
                                            className='w-100' variant="outlined" label="توضیحات"
                                            value={description} onChange={e => {
                                            setDescription(e.target.value)
                                        }}/>
                                    </Grid>
                                    <Grid sm={12} md={12} lg={12} xl={12} className='p-2 w-100'>
                                        <label id='status' className="toggle-switch-content">
                                            <span className="toggle-title">فعال / غیر فعال</span>
                                            <label className="switch" htmlFor="status">
                                                <input
                                                    type="checkbox"
                                                    id="status"
                                                    checked={enabled}
                                                    onChange={e => {
                                                        setEnabled(e.target.checked)
                                                    }}
                                                />
                                                <span className="toggle round"/>
                                            </label>
                                        </label>
                                    </Grid>
                                </Grid>
                            </Box>
                            <div className={css`
                              margin-top: .25rem;
                              display: flex;
                              align-items: end;
                              width: 100%;
                              justify-content: end`}>
                                <Button onClick={doChange} color="primary">
                                    {selectedItem === -1 ? "افزودن" : "بروزرسانی"}
                                </Button>
                            </div>
                        </section>
                    </TabPanel>
                    <TabPanel value={tabTypes.BUY_LIST} className={"flex-grow-1"}>
                        <section className={css`
                          padding: 1rem 0;
                          display: flex;
                          flex-direction: column;
                          height: 100%;
                        `}>
                            {/*<span className={css`margin-bottom: .5rem;`}>{`${itemCount} خرید ثبت شده`}</span>*/}

                            <CustomTable
                                title={"تا کنون هیچ خریدی ثبت نشده است !"}
                                header={columns}
                                data={buyRequestsList}
                            />
                            <Box className={buyRequestsList.length > 0 ? "paginationContainer" : "d-none"}>
                                <Pagination
                                    count={pageCount}
                                    color="primary"
                                    onChange={handleChange}
                                    showFirstButton showLastButton/>
                            </Box>
                        </section>
                    </TabPanel>
                </TabContext>
            </div>
        </Dialog>
    )
}
export default AddOtherNewPayments;

const tabTypes = {
    INFO: "INFO",
    BUY_LIST: "BUY_LIST",
}

const columns = [
    {id: 'number', label: '#', align: 'right'},
    {id: 'fullName', label: 'نام', align: 'right'},
    {id: 'nationalCode', label: 'کد ملی', align: 'right'},
    {id: 'phoneNumber', label: 'شماره همراه', align: 'right'},
    {id: 'amount', label: 'تعداد', align: 'right'},
    {id: 'price', label: 'قیمت کل (ریال)', align: 'right'},
    {id: 'doAt', label: 'تاریخ پرداخت', align: 'right'},
];